export const LABELS_ENVIRONNEMENTAUX = {
  AUTRE: 'autre',
  AUCUN: 'aucun',
};
